import { BehaviorSubject, Subject } from "rxjs";
import { EasyTetherStateType } from "../../pages/otcTether/types/EasyTetherStates";
import { EasyTetherPreOrder } from "../../pages/otcTether/types/EasyTetherPreOrder";
/**
 * Service To Open Crypto List In CM From Header Event Fire
 */
const openList: Subject<boolean> = new Subject();
export const CoinListService = {
  openList: (status: boolean) => openList.next(status),
  onStatusChange: openList.asObservable(),
};
/**
 * Service To Set Base Coin To Use In Other CM
 */

const activeCoin: Subject<string> = new Subject();
export const ActiveCoinService = {
  setActiveCoin: (coin: string) => activeCoin.next(coin),
  onCoinChanged: activeCoin.asObservable(),
};

/**
 * Easy Tether States
 */

const easyTetherState: BehaviorSubject<EasyTetherStateType> = new BehaviorSubject<EasyTetherStateType>(
  EasyTetherStateType.trade
);

const easyTetherTxResult: BehaviorSubject<
  EasyTetherPreOrder | undefined
> = new BehaviorSubject<EasyTetherPreOrder | undefined>(null as any);

enum TradeMode {
  BUY = "BUY",
  SELL = "SELL",
}
/**
 * User Wants To Buy Tether Or Sell ?
 */
const easyTetherMode: BehaviorSubject<TradeMode> = new BehaviorSubject<TradeMode>(
  TradeMode.BUY
);

export const EasyTetherState = {
  setCurrentState: (status: EasyTetherStateType) =>
    easyTetherState.next(status),
  onStatusChange: easyTetherState.asObservable(),
  setTxResult: (txResult: EasyTetherPreOrder | undefined) =>
    easyTetherTxResult.next(txResult),
  onTxResultChange: easyTetherTxResult.asObservable(),
  setTradeMode: (mode: TradeMode) => easyTetherMode.next(mode),
  onTradeModeChange: easyTetherMode.asObservable(),
};
